/**
* @name APP u-Planning
* @autor over.martinez@u-planner.com
* @description
* Descripcion del controlador
* @controller 
* # name: detailsByTeacherCtrl
* # alias: tDetails
*/

import statesList from '../states_list.json';
export default class detailsByTeacherCtrl {

	constructor($scope, $state, $stateParams, ngNotify, $timeout, UserInfoConstant, strategicTrackingListSrv,GlobalConfig, Setters,ReviewSrv,Requests, Validations, $location, $cookies, $mdDialog, Util) {
		this.$scope = $scope;
		this.$state = $state;
		this.$timeout = $timeout;
		this.ngNotify = ngNotify;
		this.$location = $location;
		this.$mdDialog = $mdDialog;
		this.$stateParams = $stateParams;
		this.$cookies = $cookies;
		this.services = strategicTrackingListSrv;
		this.userinfo = null;
		this.plans = [];
		this.Setters = Setters;
		this.formatActivity = this.Setters.formatActivity(Setters.setTagName(Validations))
		this.activities = [];
		this.plan = []
		this.states = [];
		this.teacher = null;
		this.state = null;
		this.details = {};
		this.entries = null;
		this.role = {};
		this.Requests = Requests
		this.ReviewSrv = ReviewSrv
		this.Validations = Validations
		this.Util = Util
		this.$scope.UserInfoConstant = UserInfoConstant;
		this.$scope.$watch('UserInfoConstant[0].details[0]', (details, before) => {
			if (details !== undefined) {
				this.userinfo = details.user;
				this.userinfo.role_id = this.$cookies.get('hasRoleId');
				this.subModule = this.$stateParams.idModule;
				this.main();
			}
		});

		this.contentHeaderCSS = ['col-md-6', 'no-padding', 'text-center', 'font-normal', 'text-sm'],
		this.headingCSS = ['col-md-3', 'no-padding', 'text-center', 'text-sm', 'font-normal'],
		this.contentCSS = ['col-md-3', 'no-padding', 'text-center', 'text-sm', 'text-azul'],
		this.contentNameCSS = ['col-md-6', 'no-padding'],
    	this.timeCSS = ['col-md-4', 'no-padding', 'text-center', 'text-azul', 'text-xs'],

		this.currentStage = $stateParams.stage
		this.currentModule = this.$stateParams.idModule
		this.modules = GlobalConfig.modules // Object.keys(GlobalConfig.modules)
		this._moduleName = Object.keys(this.modules).find(key => this.modules[key] == this.currentModule)
		this.formatSubjectActivity = this.Requests.formatSubjectActivity(this.Requests.normalizeActivity(this.Requests.setNullHours))
		this.routeDetails = this.Requests.routeDetails(this.Validations, this.Requests.setNullHours, this.Requests.setStudentAttentionData, this.formatSubjectActivity)
	}

	main() {
		this.checkRole();
		this.getTeacherData();
		this.getPlans(() => {
			this.states = statesList.data;
			for (let i in this.states) {
				if (this.states[i].id_code == this.$stateParams.stateId) {
					this.state = this.states[i];
				}
			}
			this.getActivities();
		});
	}

	showTime(activity) {
		return activity.timeRangeTypeId === 1 ? (activity.periodName || activity.periodicityName) : this.activityDates(activity)
	}

	activityDates (activity) {
		return this.Util.setDate(activity.startDate) + ' - ' + this.Util.setDate(activity.endDate)
	}

	checkRole() {
		this.services.get.typeRole({roleId: this.userinfo.role_id}).$promise.then((response) => {
			if (!response.status) {
				this.ngNotify.set('Ocurrio un error en el servicio', 'warn');
			} else {
				this.role = response.data[0];
			}
		}, (err) => {
			this.ngNotify.set('Imposible conectar con el servicio', 'error');
		});
	}

	bitacora(title,ev) {
		this.entries.title =  title;
		this.$mdDialog.show({
			controller: 'bitacoraModalCtrl',
			controllerAs: 'bit',
			template: require('./bitacoraModal/bitacoraModal.html'),
			parent: angular.element(document.body),
			targetEvent: ev,
			locals: {data: this.entries}, 
			clickOutsideToClose: true,
			fullscreen: true
		});
	}

	getTeacherData() {
		let params = {
			idModule: this.subModule,
			idAcaUnit: this.$stateParams.acaUnit,
			userId: this.$stateParams.teacherId,
		}
		this.services.list.getDataTeacher(params).$promise.then((response) => {
			if (!response.status) {
				this.ngNotify.set('Ocurrio un error en el servicio', 'warn');
			} else {
				this.teacher = response.data[0];
			}
		}, (err) => {
			this.ngNotify.set('Imposible conectar con el servicio', 'error');
		});
	}

	updateFilter(text) {
	}

	loadDetails(item) {
		this.childrenDetails = []
		this.activitySelected = item;
		this.details.isEmpty = true;
		this.details.tagName = ''
		if (item === undefined) {
			this.details.name = 'Sin información';
			this.isLoadingDetails = false;
			return false;
		}
		this.details.isEmpty = false;
		this.getEntries(item);
		this.getMoreDetails(item)
		//this.getDetails(item);
		let descrip = item.activityName || item.activityTypeName;
		this.isLoadingDetails = true;
		this.details.name = item.asignatureName || item.academicUnitName || item.otherActivityItemName || item.activityTypeNameCombo || item.activityTypeName;
		this.details.description = descrip + ' - ' + (item.description || item.otherActivityItemName || item.name || 'Sin descripción');
		this.details.totalHoursPlanned = item.totalHoursPlanned;
		this.details.totalHoursExecuted = item.totalHoursExecuted;
		this.details.porcentExecuted = (item.totalHoursPlanned > 0) ? Math.round(((item.totalHoursExecuted/item.totalHoursPlanned)*100)) : '';
		this.details.tagName = item.tagName;
		this.details.progressBar = (this.details.porcentExecuted < 0 ) ? 0 : (this.details.porcentExecuted > 100 ? 100 : this.details.porcentExecuted) ;
		this.details.status = this.states[item.Estado-1].ds_name;
		this.details.className = this.getClassName(item.activityTypeId);
		this.isLoadingDetails = false;
	}

	getMoreDetails(item) {
		this.setDetailsHeader = this.Requests.setDetailsHeader(this.Validations)
  		this.getActivityDetails = this.Requests.getActivityDetails(this.ReviewSrv, this.setDetailsHeader);
		this.getActivityDetails(this._moduleName, item).then((data) => {
			if (data === 'error in communication') {
				this.details = null
			} else {
				this.childrenData = this.routeDetails(this._moduleName, item, data)
				this.childrenDetails = []

        		if (this.childrenData.data) {
        			if (this.childrenData.children) {
        				this.childrenDetails.push({
        					data: this.childrenData.children || {}, type: "project"
        				})
        			}

        			if (this.childrenData.planning) {
	        			this.childrenDetails = [
		        			{data: this.childrenData.planning || {}, type: 'planning'},
		        			{data: this.childrenData.teaching || {}, type: "teaching"}
	        			]
        			}
        		} else {
        			this.childrenDetails = []
        		}
			}
		}, (err) => {
			this.ngNotify.set('Imposible conectar con el servicio', 'error');
		});
	}

	getClassName(type) {
		if ([5,3,4,10].indexOf(type) >= 0) {
			return 'verde';
		}
		if ([8,12].indexOf(type) >= 0) {
			return 'morado';
		}
		if ([11,7, 19].indexOf(type) >= 0) {
			return 'azul';
		}
		return 'verde';
	}

	getEntries(item) {
		let params = {
			workplanTeacherId: item.workplanTeacherId,
			activityTypeId: item.activityTypeId,
			teacherId: this.$stateParams.teacherId
		}
		this.entries = null;
		this.services.get.entries(params).$promise.then((response) => {
			if (!response.status) {
				this.ngNotify.set('Ocurrio un error en el servicio', 'warn');
			} else {
				this.entries = response;
				this.entries.params = params;
			}
		}, (err) => {
			this.ngNotify.set('Imposible conectar con el servicio', 'error');
		});
	}

	getActivities() {
		let params = {
			teacherId: this.$stateParams.teacherId,
			workplanId: (this.plan.length > 0)? this.plan.map((plan) => {return plan.workplanId}):0,
			idState: (this.state != null) ? this.state.id_code : 0, 
			roleId:(this.userinfo.role_id != null) ? this.userinfo.role_id : 0,
			userId: (this.userinfo.id != null) ? this.userinfo.id : 0,
			submoduleId: (this.subModule != null) ? this.subModule : 0,
			academic_unit: (this.$stateParams.acaUnit != null) ? this.$stateParams.acaUnit : 0
		}
		// if (this.plan.length == 1) {params.workplanId.push(0) }
		
		this.details = {};
		this.isLoadingDetails = true;
		this.entries = null
		let serviceAux = this.getServiceToList();
		serviceAux(params).$promise.then((response) => {
			if (!response.status) {
				this.ngNotify.set('Ocurrio un error en el servicio', 'warn');
			} else {
				this.activities = this.Setters.sortActivitiesList(this.formatActivity(response.data, 0));
				this.loadDetails(this.activities[0]);
			}
		}, (err) => {
			this.ngNotify.set('Imposible conectar con el servicio', 'error');
		});
	}

	getParams(item) {
		if (this.subModule == '2' && item.activityTypeId == 3) {
			return {
				asignatureId: item.asignatureId,
				teacherId: item.teacherId,
				workplanId: item.workplanId
			}
		} else {
			return {
				activityTypeId: item.activityTypeId,
				workplanTeacherActivityId: item.workplanTeacherActivityId,
			}
		}
	}

	remove() {
		const params = {
			idActivity:this.activitySelected.workplanTeacherActivityId,
			idEvaluator:this.userinfo.id,
			idRol:this.userinfo.role_id,
			idTeacher:this.$stateParams.teacherId,
			isStrategicTracing:false
		}
		let description = ''
		if(this.activitySelected.activityTypeName)
			description = 'Profesor: Se ha eliminado una actividad de "'+
							this.activitySelected.activityTypeName+
							'" del módulo de Seguimiento estratégico'
		else
			description = 'Se ha eliminado una actividad de seguimiento estratégico.'
		
		const post1 = {
			idTeacher: this.$stateParams.teacherId,
			dsName: 'Notificación de eliminación de actividad (Seguimiento estratégico)',
			dsDescription: description,
			idNotification_delivery_type: 1,
			is_grouped: 1
		}

		this.services.tracking.remove(params).$promise.then((response) => {
			if (!response.status) {
				this.ngNotify.set('Ocurrio un error en el servicio', 'warn');
			} else {

				this.services.addNotificationsTransactions.add(post1).$promise.then(function (dataReturn) 
                {
                    if (dataReturn.status) {            
                        console.log("ok notification eliminación actividad de módulo", dataReturn)
                    } else {
                        console.log("Error Comunications")
                    }
                    }, function (data) {
                        console.log(data)
                })
				this.update();
				this.ngNotify.set('Actividad a sido retirada de seguimiento estratégico', 'success');
			}
		}, (err) => {
			this.ngNotify.set('Imposible conectar con el servicio', 'error');
		});
	}

	update() {
		this.teacher.cantidad--
		for (let i in this.activities) {
			if (this.activities[i].workplanTeacherActivityId == this.activitySelected.workplanTeacherActivityId) {
				this.activities.splice(i, 1);
				break;
			}
		}
		this.loadDetails(undefined);
	}

	confirmRemove(ev) {
		this.$mdDialog.show({
			controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
				this.close = (response) => {
					$mdDialog.hide(response)
				}
			}], 
			controllerAs: 'confirm',
			template: require('./modalConfirm.html'),
			clickOutsideToClose: false
		}).then((response) => {
			if (response) {
				this.remove();
			}
		});
	}

	getServiceToList() {
		if (this.subModule == '2')
			return this.services.get.activities;
		if (this.subModule == '3')
			return this.services.get.actAcademics;
		if (this.subModule == '4')
			return this.services.get.actExtension;
		if (this.subModule == '5')
			return this.services.get.actConsolidation;
		if (this.subModule == '6')
			return this.services.get.actInvestigation;
	}

	getServiceDetails() {
		if (this.subModule == '2')
			return this.services.get.details;
		if (this.subModule == '3')
			return this.services.get.acaDetails;
		if (this.subModule == '5')
			return this.services.get.consDetails;

		return this.services.get.details;
	}

	getPlans(callback) {
		this.services.get.plans({teacherId: this.$stateParams.teacherId}).$promise.then((response) => {
			if (!response.status) {
				this.ngNotify.set('Ocurrio un error en el servicio', 'warn');
			} else {
				this.plans = response.data;
				let wid_params = (this.$stateParams.workplanId !== undefined) ? this.$stateParams.workplanId.split('-') : [0];
				
				for (let i in this.plans) {
					for (let x in wid_params) {
						if (this.plans[i].workplanId == wid_params[x]) {
							this.plan.push(this.plans[i])
						}
					}
				}
				
				callback();
			}
		}, (err) => {
			this.ngNotify.set('Imposible conectar con el servicio', 'error');
		});
	}
	
	volver() {
		let params = {
			acaUnit: 0,
			workplanId: (this.plan != null) ? this.plan.workplanId : undefined,
			stateId: (this.state != null) ? this.state.id_code : undefined
		}
		let urls = {
			"2": "strategicTracking.strategicTrackingTeacher", 
			"3": "strategicTracking.strategicTrackingAcadManagement", 
			"4": "strategicTracking.strategicTrackingExtension", 
			"5": "strategicTracking.strategicTrackingConsolidation", 
			"6": "strategicTracking.strategicTrackingInvestigation", 
			"0": "strategicTracking.strategicTrackingGlobalView", 
		}

		this.$state.go(urls[0], params);
	}

	reloadStage() {
		let plansId = this.plan.map(function(plan) {
			return plan.workplanId;
		}).reduce((before, current) => {
			let val = (before !== '') ? before + '-' : '';
			return val + current.toString()
		},'')
		let params = {
			idModule: this.subModule,
			acaUnit: this.$stateParams.acaUnit,
			teacherId: this.$stateParams.teacherId,
			workplanId: (plansId.length > 0) ? plansId : undefined,
			stateId: (this.state != null) ? this.state.id_code : undefined
		}

		let urls = {
			"2": "strategicTracking.strategicTrackingTeacherDetails", 
			"3": "strategicTracking.strategicTrackingAcadManagementDetails", 
			"4": "strategicTracking.strategicTrackingExtensionDetails", 
			"5": "strategicTracking.strategicTrackingConsolidationDetails", 
			"6": "strategicTracking.strategicTrackingInvestigationDetails", 
			"0": "strategicTracking.strategicTrackingGlobalViewDetails", 
		}

		this.$state.go(urls[params.idModule], params);
	}
}

detailsByTeacherCtrl.$inject = ['$scope', '$state', '$stateParams', 'ngNotify', '$timeout', 'UserInfoConstant', 'strategicTrackingListSrv','GlobalConfig', 'Setters','ReviewSrv','Requests', 'Validations', '$location', '$cookies', '$mdDialog', 'Util'];


// WEBPACK FOOTER //
// ./src/app/u-faculty/strategicTracking/detailsByTeacher/detailsByTeacherCtrl.js